import { Country, PaymentMethodType } from '@afterpay/types'
import { VerificationMethod } from '../verify/types'

export enum DeviceType {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
}
export interface CashAuthQuery {
  token: string
  deviceType: DeviceType
  email?: string
  phone?: string
}

export enum CashAuthStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  DECLINED = 'DECLINED',
}

export interface CashAuth {
  status: CashAuthStatus
  mobileUrl?: string | null
  desktopUrl?: string | null
  refreshesAt?: string | null
  qrCodeUrl?: string | null
}

export interface AuthLoginRequest {
  username: string
  password: string
  'remember-me': boolean
}

export interface AuthLoginResponse {
  user: {
    id: number
    name: string
    requires2fa: boolean
    shouldAllowEmail: boolean
    promotePersistentLogin: boolean
  }
  status: 'success' | string
}

export enum TwoFactorChallengeType {
  PHONE_NUMBER = 'PHONE_NUMBER',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  CREDIT_CARD = 'CREDIT_CARD',
  LAST_NAME = 'LAST_NAME',
}
export interface TwoFactorChallengeRequest {
  email: string
  code: number
  twoFactorChallenges: Partial<Record<TwoFactorChallengeType, string>>
  countryCode: Country
}

export interface RiskExtra {
  orderToken: string
  checkpoint: 'CHECKOUT_CONFIRM'
  topazTraceId: string
  paymentMethodId?: string
  paymentMethodType?: PaymentMethodType
}

export interface Check2FACodeRequest {
  code: string
  riskExtra?: RiskExtra
  profilingSessionId: string
}

export interface authResetCodeSendRequest {
  email?: string
  sendBy: VerificationMethod
}
export enum AuthCheckCodeStatus {
  PASS = 'PASS',
  TWO_FACTOR_REQUIRED = 'TWO_FACTOR_REQUIRED',
}

export interface PasswordResetTwoFactorChallenge {
  type: TwoFactorChallengeType
  hint: string
}
export interface AuthCheckCodeResponse {
  status: AuthCheckCodeStatus
  challenges: PasswordResetTwoFactorChallenge[]
}
export interface AuthCheckCodeRequest {
  code: string
  email: string
}
export interface AuthResetRequest {
  code: string
  password: string
  'remember-me': boolean
  email: string
}
